jQuery(document).ready(function () {

    jQuery(document).foundation();

    var $ = jQuery;

    var socialIcons = [];
    var suppress = false;
    jQuery(document).on('click', function () {
        if (!suppress) {
            socialIcons.map(function (icon) {
                jQuery(icon).removeClass("is-flex-important")
            });
            socialIcons = [];
        }
    });
    jQuery('.social-placeholder').on('click', function () {
        var currentElement = jQuery(this).next();
        var position = socialIcons.indexOf(currentElement.get(0));
        if (position === -1) {
            socialIcons.push(currentElement.get(0));
            currentElement.addClass("is-flex-important");
        } else {
            socialIcons.splice(position, 1);
            currentElement.removeClass("is-flex-important");
        }
        suppress = true;
        setTimeout(function () {
            suppress = false;
        }, 100);

    });

    // vars for caption repositioning on window resize
    var my_image = null;
    var responsive_caption = null;
    var caption_exists = false;

    // To adjust the caption on window resize
    $(window).resize(function () {

        // only adjust caption if the fancybox image is being shown
        if (caption_exists == true) {
            var new_image_css = null;
            var img_height = my_image[0].height;
            new_image_css = my_image[0].parentElement.style.cssText;
            responsive_caption[0].style.cssText = new_image_css;
            responsive_caption.css('margin-top', img_height);
        }
    });



    // Post-load styling. Home page BW posts have a yellow background
    // that breaks out of the 12-grid. We pull the background out, but
    // have to rejig all heights according to the Article Content .medium-excerpt
    // height. Also unset max-height, top styles for some things.
    function resizeBWFeature(articleContainer, articleContent, backImage) {
        articleContainer.height(articleContent.height() + 25);
        backImage.height(articleContent.height() + 25);
        backImage.css('margin-bottom', -backImage.height());
        if (window.innerWidth >= 1024) {
            backImage.width(400 - (363 - articleContent.find('a img')[0].clientWidth));
        } else {
            backImage.width(window.innerWidth / 2 + 50);
        }
    }
    jQuery('.article-in-archive.blog-id-2').each(function () {
        var articleContainer = jQuery(this);
        var articleContent = articleContainer.find('.medium-excerpt');
        var backImage = articleContainer.find('.yellow-background');
        articleContainer.css('max-height', 'none');

        resizeBWFeature(articleContainer, articleContent, backImage);
        jQuery(window).resize(function () {
            resizeBWFeature(articleContainer, articleContent, backImage);
        });
    });

    var socialIcons = [];
    var suppress = false;
    jQuery(document).on('click', function () {
        if (!suppress) {
            socialIcons.map(function (icon) {
                jQuery(icon).removeClass("is-flex-important")
            });
            socialIcons = [];
        }
    });
    jQuery('.social-placeholder').on('click', function () {
        var currentElement = jQuery(this).next();
        var position = socialIcons.indexOf(currentElement.get(0));
        if (position === -1) {
            socialIcons.push(currentElement.get(0));
            currentElement.addClass("is-flex-important");
        } else {
            socialIcons.splice(position, 1);
            currentElement.removeClass("is-flex-important");
        }
        suppress = true;
        setTimeout(function () {
            suppress = false;
        }, 100);

    });
});
